module.exports = __webpack_public_path__ + "img/circleitem_title_icon.e56cfe65.svg";